import * as Yup from 'yup';
import { reverseShape } from 'Helpers/reverse-shape';
import { email } from 'Utils/validations';

const ForgotPasswordSchema = Yup.object().shape(
  reverseShape({
    email: email.required(),
    accountType: Yup.mixed().oneOf(['BUSINESS_ACCOUNT', 'INDIVIDUAL_ACCOUNT']),
    // password: Yup.string()
    //   .matches(/^(?=.*\d)(?=.*[A-Z])(?=.*[\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?])[0-9a-zA-Z\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?]+$/)
    //   .min(6)
    //   .max(12)
    //   .required(),
  })
)

export default ForgotPasswordSchema;
